import { getApiFromModule } from "./GetContentsByModule";
import { Share } from "react-native";
import { getTranslatedString } from "./FindifyTranslatedString";
import { SimpleHeaderAction } from "../components/FindifySimpleHeader";

export const PlaceListInitialUseEffect = ({
    props,
    setContents,
    setLoaded,
    setModule,
    setSelectedCategories,
    findifyDataContext,
    setAvailableModuleCategories,
    contents,
    ignoreContentsWithoutCategory,
    pageModule,
}: {
    props: any,
    setContents: Function,
    setLoaded: Function,
    setModule: Function,
    setSelectedCategories: Function,
    findifyDataContext: any,
    setAvailableModuleCategories: Function,
    contents: any
    ignoreContentsWithoutCategory?: boolean,
    pageModule?: string,
}) => {
    const module = props?.route?.params?.module ?? pageModule;
    const category = props?.route?.params?.category;
    setModule(module);
    let selectedCats: number[] = [];
    if (category && category !== '') {
        selectedCats = [+category];
        setSelectedCategories(selectedCats);
    }
    const categoriesApi = getApiFromModule('categories', findifyDataContext);
    // On category change 
    categoriesApi.getList(0, 100, null, { category_type: `${module}`, active: 1 }, null).then((data: any) => {
        setAvailableModuleCategories(data?.results);
    })

    if (!ignoreContentsWithoutCategory) {
        loadContentsPageFromApi(selectedCats, contents, module, findifyDataContext, setContents).then(() => {
            setLoaded(true);
        });
    } else {
        setLoaded(true);
    }
}

export const PlaceListOnSelectedCategoryChangeEffect = ({
    loaded,
    selectedCategories,
    setContents,
    module,
    findifyDataContext,
    setActionsList,
    availableModuleCategories,
    t,
}: {
    loaded: boolean,
    selectedCategories: number[],
    setContents: Function,
    module: string,
    findifyDataContext: any,
    setActionsList: (actionsList: SimpleHeaderAction[]) => void,
    availableModuleCategories: any[],
    t: Function
}) => {
    // On category change reset current items
    if (loaded) {
        setContents([]);
        loadContentsPageFromApi(selectedCategories, [], module, findifyDataContext, setContents);
    }

    setActionsList([{
        icon: 'share-outline',
        action: async () => {
            const result = await Share.share({
                title: (selectedCategories.length === 1 ?
                    getTranslatedString(
                        availableModuleCategories.find((cat: any) => cat.category_id === selectedCategories[0])?.name, findifyDataContext) :
                    t('modules.content_types.' + module)) + ' - ' + getTranslatedString(findifyDataContext?.workspace?.name, findifyDataContext) + ' - Findify',
                message: `https://${findifyDataContext.workspace?.primary_domain?.domain_name ?? 'links.findify.cloud'}/dynamicLink?workspace_id=${findifyDataContext.workspace?.workspace_id}&type=list&module=${module}${selectedCategories.length === 1 ? `&category_id=${selectedCategories[0]}` : ''}`,
            }, {
                dialogTitle: getTranslatedString(findifyDataContext?.workspace?.name, findifyDataContext) + ' - Findify',
            });
        }

    }]);
}

export const loadContentsPageFromApi = async (selectedCategories: number[], listItems: any[], module: string, findifyDataContext: any, setListItems: Function) => {
    const api = getApiFromModule(module, findifyDataContext);
    // On category change(first load also)
    let filters = {};
    if (selectedCategories.length !== 0) {
        filters = { 'categories.category.category_id_in': JSON.stringify(selectedCategories) }
    }
    // The public API expects the sort fields inside the `orderby` query
    // parameter. Passing the fields directly makes them be treated as
    // filters (e.g. make_public_on=DESC), resulting in an empty list.
    const orderby = module === 'points_of_interest'
        ? { orderby: JSON.stringify({ make_public_on: 'DESC', point_of_interest_id: 'DESC' }) }
        : module === 'contents'
            ? { orderby: JSON.stringify({ public_date: 'DESC', content_id: 'DESC' }) }
            : null;
    const data = await api?.getList(listItems.length, 10, null, filters, orderby);
    const results = data?.results ?? [];
    if (results.length > 0) setListItems([...listItems, ...results]);
    return results.length === 10;
}
